import { render } from "./BaseItem.vue?vue&type=template&id=39576bfa&scoped=true"
import script from "./BaseItem.vue?vue&type=script&lang=js"
export * from "./BaseItem.vue?vue&type=script&lang=js"

import "./BaseItem.vue?vue&type=style&index=0&id=39576bfa&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39576bfa"]])

export default __exports__